// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__sXuHQ","item":"styles_item__YsUG3","title":"styles_title__K1pPI","count":"styles_count__g3VNI","active":"styles_active__JF3Lr"};